import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 37 35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M8.57 10.002h3.93c1.383 0 2.5 1.117 2.5 2.5s-1.117 2.5-2.5 2.5h-10a2.497 2.497 0 0 1-2.5-2.5v-10c0-1.383 1.117-2.5 2.5-2.5S5 1.119 5 2.502v4l1.375-1.375c6.836-6.836 17.914-6.836 24.75 0s6.836 17.914 0 24.75-17.914 6.836-24.75 0a2.504 2.504 0 0 1 0-3.54 2.504 2.504 0 0 1 3.54 0c4.882 4.884 12.796 4.884 17.679 0 4.883-4.882 4.883-12.796 0-17.679s-12.797-4.883-17.68 0z"
    }, null, -1)
  ])))
}
export default { render: render }